import React,{useState,useRef,useEffect} from 'react'
import { MoreVertical,Pencil,Trash2 } from 'lucide-react'
import { FaFileAudio, FaFilePdf, FaFileWord, FaFilePowerpoint, FaFileAlt, FaCode } from "react-icons/fa";
import { FaEdit, FaTrash, FaPlay} from 'react-icons/fa';
import DeleteCMLModal from './DeleteCMLModal';
import EditLessonModal from './EditLessonModal';
import CoursePreviewModal from './CoursePreviewModal';
import LessonResources from './LessonResources';
const ContentLesson = ({module,fetchCourseContent}) => {
const [deleteId, setDeleteId] = useState(null);
const [editId,setEditId]=useState(null)
const [editLessonModal,setEditLessonModal]=useState(false)
const [preview,setPreview]=useState(null)
const [openDropdownIndex, setOpenDropdownIndex] = useState(null) 
const [openResources,setOpenResources]=useState(null)
    const dropdownRef = useRef(null)
     useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdownIndex(null)
      }
    }
  
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [dropdownRef])
const getLessonIcon = (type,file) => {
  switch (type) {
    case "video":
      return <FaPlay className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)} />;
    case "audio":
      return <FaFileAudio className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)}/>;
    case "pdf":
      return <FaFilePdf className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)}/>;
    case "doc":
      return <FaFileWord className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)}/>;
    case "ppt":
      return <FaFilePowerpoint className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)}/>;
    case "txt":
      return <FaFileAlt className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)}/>;
    case "code":
      return <FaCode className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)}/>;
    default:
      return <FaFileAlt className="lesson-icon" style={{cursor:"pointer"}} onClick={()=>setPreview(file)}/>; // fallback
  }
};
const handleEditLesson = (lesson) => {
  setEditId(lesson.id);          // ✅ Set the current lesson ID
  setEditLessonModal(true);      // ✅ Open the edit modal
};
  return (
    <>
      {module.lessons?.length > 0 ? (
  module.lessons.map((lesson) => (
    <div key={lesson.id} className="px-2 md:px-8 pb-4">
      <div className="flex flex-col bg-white border border-gray-200 rounded-xl p-4 hover:border-gray-300 transition-all shadow-sm">

        <div className="flex justify-between w-full items-center">
          {/* Lesson Info */}
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center flex-shrink-0">
              {getLessonIcon(lesson.type, lesson.content_file)}
            </div>

            <div>
              <span className="text-sm font-semibold text-gray-900">
                {lesson.title || '-'}
              </span>
            </div>

            {lesson.resources?.length > 0 && (
              <button
                onClick={() => setOpenResources((v) => (v === lesson.id ? null : lesson.id))}
                className="ml-2 px-3 py-1.5 bg-[#e8f0f7] text-[#0f6abf] text-xs font-medium rounded-lg hover:bg-[#d0e0f0] transition-colors"
              >
                additional resources
              </button>
            )}
          </div>

          {/* Lesson Actions */}
          <div className="relative">
            <button
              className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors"
              onClick={() =>
                setOpenDropdownIndex(openDropdownIndex === lesson.id ? null : lesson.id)
              }
            >
              <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" />
              </svg>
            </button>

            {openDropdownIndex === lesson.id && (
              <div
                ref={dropdownRef}
                className="absolute right-0 mt-2 bg-white rounded-xl shadow-lg border border-gray-200 py-1 min-w-[140px] z-10"
              >
                <button
                  onClick={() => handleEditLesson(lesson)}
                  className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                  Edit
                </button>
                <button
                  onClick={() => setDeleteId(lesson.id)}
                  className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-red-500 hover:bg-red-50 transition-colors"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                  </svg>
                  Delete
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Lesson Resources */}
        <LessonResources
          lesson={lesson}
          openResources={openResources}
          fetchCourseContent={fetchCourseContent}
        />
      </div>
    </div>
  ))
) : (
  <div className="px-2 md:px-8 py-8 text-center">
    <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
      <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
      </svg>
    </div>
    <p className="text-gray-500">No lessons added yet</p>
    <p className="text-sm text-gray-400 mt-1">Start by creating your first lesson for this module</p>
  </div>
)}
    <DeleteCMLModal deleteId={deleteId} setDeleteId={setDeleteId} type="lesson" fetchCourseContent={fetchCourseContent}/>
     {
       editLessonModal &&  <EditLessonModal editId={editId} editLessonModal={editLessonModal} setEditLessonModal={setEditLessonModal} fetchCourseContent={fetchCourseContent}/>
     }
     {
       preview !==null && <CoursePreviewModal file={preview} setPreview={setPreview}/>
     }
    </>
  )
}

export default ContentLesson
